import createStyleSheet from 'src/utilities/createStyleSheet'

export const cameraConfigStyles = createStyleSheet({
  buttonEdit: {
    color: 'white',
    width: '180px',
    height: '40px',
    textTransform: 'none',
    backgroundColor: '#20bc30',
    '&:hover': {
      backgroundColor: '#00850e',
    },
  },
  paper: {
    borderRadius: '8px',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 1.5,
    height: '100%',
    maxHeight: '84vh',
    overflow: 'auto',
    background: 'white',
  },
  cancelButton: {
    width: '180px',
    height: '40px',
    marginBottom: 0,
    border: '1px solid',
    fontFamily: 'Inter',
    boxShadow: 'none',
    textTransform: 'none',
  },
  addButton: {
    width: '180px',
    height: '40px',
    fontFamily: 'Inter',
    boxShadow: 'none',
    textTransform: 'none',
  },
  content: {
    overflow: 'auto',
  },
  loading: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'flex-end',
    alignSelf: 'flex-end',
    padding: 0,
    margin: 0,
  },
})
